import React, { useRef, useState } from "react";

function SendChatTranscriptForm(props) {
  const trancriptRef = useRef();
  const messageRef = useRef();
  const [showError, setShowError] = useState(false);
  let emailPlaceholderValue = "Please Enter Email";

  const customDesign = props.config?.customDesign ?? {};

  const handleChange = () => setShowError(false);

  const onSend = () => {
    let emailId = messageRef.current.value;

    if (!emailId.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      setShowError(true);
    } else props.onSendChatTranscript(emailId);
  };

  const buttonStyle = () => {
    return {
      ...props.config?.customDesign?.chatTranscriptInitialFormStartButton,
      border: showError ? "1px solid red" : "1px solid black",
    };
  };

  const onClickInput = (e) => {
    if (e.target.value === emailPlaceholderValue) {
      messageRef.current.value = "";
    }
  };

  const onInputOut = (e) => {
    if (!e.target.value || !e.target.value.trim) {
      messageRef.current.value = emailPlaceholderValue;
    }
  };

  return (
    <div ref={trancriptRef} className="s360-chat-full-screen-container">
      <div className="s360-chat-transcript-email-form-container">
        <div
          className="s360-chat-transcript-default-close-icon"
          onClick={props.onClose}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24.674 24.668"
          >
            <defs></defs>
            <path
              style={customDesign?.chatTranscriptDefaultCloseIcon}
              d="M26.546,23.623l8.813-8.813a2.065,2.065,0,0,0-2.92-2.92L23.625,20.7,14.813,11.89a2.065,2.065,0,1,0-2.92,2.92l8.813,8.813-8.813,8.813a2.065,2.065,0,1,0,2.92,2.92l8.813-8.813,8.813,8.813a2.065,2.065,0,1,0,2.92-2.92Z"
              transform="translate(-11.285 -11.289)"
            />
          </svg>
        </div>
        <div
          className="s360-chat-transcript-email-form-textbox-container"
          style={customDesign?.chatTranscriptEmailFormTextContainer}
        >
          <input
            type="text"
            ref={messageRef}
            className="s360-initial-form-textbox-input"
            onClick={onClickInput}
            onChange={handleChange}
            onBlur={onInputOut}
            placeholder={emailPlaceholderValue}
            style={customDesign?.chatTranscriptInitialFormTextboxInput}
          />
        </div>
        <div className="s360-chat-transcript-send-button-container">
          <input
            className="s360-initial-form-start-button"
            type="button"
            value="Send"
            onClick={onSend}
            style={buttonStyle()}
          />
          {!!showError && (
            <p
              style={{
                color: "red",
                marginTop: "-22%",
                marginLeft: "-59%",
                fontSize: "11px",
              }}
            >
              Enter Valid Email
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default SendChatTranscriptForm;
